<script>
  import axios from "axios";
  import { useAppStore } from "@/store/modules/app";
  import HeaderMain from "./components/template/HeaderMain.vue";
  import FooterMain from "./components/template/FooterMain.vue";
  import MainLoader from "@/components/template/ui/MainLoader.vue";
  import AppLoader from "@/components/template/ui/AppLoader.vue";
  import Toast from "primevue/toast";
  import ConfirmDialog from "primevue/confirmdialog";
  import {mapActions, mapWritableState} from "pinia";

  export default {
    data() {
      return {
        version: '1.5.1-beta',
        tg: null
      }
    },
    components: {AppLoader, MainLoader, HeaderMain, FooterMain, ConfirmDialog, Toast},
    methods: {
      ...mapActions(useAppStore, ['setAppStarted', 'startLoading', 'stopLoading']),

      /**
       * Инициализация axios
       */
      initApp() {
        const $this = this;
        let WebApp = window.Telegram.WebApp;
        const chatId = (WebApp.initDataUnsafe.user !== undefined) ? WebApp.initDataUnsafe.user.id : '876877307';

        if (WebApp.initDataUnsafe.start_param) {
          const tgLink = '/' + WebApp.initDataUnsafe.start_param.replace(/_/g, '/')
          this.$router.push(tgLink);
        }

        axios.defaults.baseURL = $this.domain + $this.baseApi;
        axios.defaults.headers.common['Authorization'] = chatId;

        axios.post('/app/info')
            .then(function (resp) {
              $this.setAppStarted();

              axios.interceptors.request.use(config => {
                console.log("Axios request", config);

                if (config.skipInterceptor) {
                  return config; // Пропускаем обработку
                }

                $this.startLoading();
                return config;
              });

              axios.interceptors.response.use(response => {
                console.log("Axios response", response.data)
                $this.stopLoading();
                return response;
              });

              if (resp.data.error === undefined) {
                $this.userId = resp.data.result.userId;
                $this.userRole = resp.data.result.userRole;
                $this.listUsers = resp.data.result.users;
                $this.listProjects = resp.data.result.projects;
              } else {
                if (resp.data.error === "Unauthorized") {
                  $this.$router.push('/auth');
                }
              }
            })
            .catch(function (error) {
              // TODO: обработка ошибки
              console.log(error);
            });
      },
      postToServer(endpoint, params, callback) {
        const $this = this;

        return axios.post(endpoint, params)
            .then(callback)
            .catch(function (error) {
              $this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: error, life: 3000 });
            });
      }
    },
    computed: {
      ...mapWritableState(useAppStore, ['userId', 'userRole', 'listUsers', 'listProjects', 'isAppStarted', 'isLoading', 'domain', 'baseApi']),

      /**
       * Получаем значение свойства backgroundImage из мета-тега маршрута
       * @returns {(function(): *)|string|*}
       */
      bgImg() {
        return this.$route.meta.bgImg || '';
      }
    },
    mounted() {
      this.initApp();
    }
  }
</script>

<template>
  <HeaderMain v-if="userId" />
    <main
        class="main"
        :class="{'main--bg': bgImg !== ''}"
        :style="{ backgroundImage: bgImg ? 'url(' + bgImg + ')' : '' }"
    >
      <MainLoader/>
      <router-view :key="$route.fullPath" />
    </main>
  <FooterMain v-if="userId" />
  <AppLoader/>
  <ConfirmDialog/>
  <Toast position="top-center" />
</template>